// extracted by mini-css-extract-plugin
export default {"container":"EnterOtpModalBody_container__NI14S","resendOtp":"EnterOtpModalBody_resendOtp__trfH1"};